var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(['wxjobchance', 'wxjobDetails',  'zxjobchance', 'zxjobDetails'].includes(_vm.$route.name))?_c('router-view',{staticStyle:{"flex":"1","display":"flex"}}):[_c('Header'),_vm._v(" "),_c('router-view',{staticStyle:{"flex":"1","display":"flex"}}),_vm._v(" "),_c('Footer')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e236902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 